import api from '../../api'

export async function getDividends(params) {
  const response = await api.request({
    method: 'get',
    otcAPI: true,
    url: '/company/dividends',
    params
  })
  return response.data
}

export async function getSplits(params) {
  const response = await api.request({
    method: 'get',
    otcAPI: true,
    url: '/company/splits',
    params
  })
  return response.data
}

export async function getSharesDilution(params) {
  const response = await api.request({
    method: 'get',
    otcAPI: true,
    internalAPI: true,
    url: `/share-data-api/shares-dilution`,
    params
  })
  return response.data
}

export async function getShares(params) {
  const response = await api.request({
    method: 'get',
    otcAPI: true,
    internalAPI: true,
    url: `/share-data-api/shares`,
    params
  })
  return response.data
}

export async function getSharesSplit(params) {
  const response = await api.request({
    method: 'get',
    otcAPI: true,
    internalAPI: true,
    url: `/share-data-api/shares-split`,
    params
  })
  return response.data
}